import ComponentWithSocket from '../../lib/component';
import { Component, Watch } from 'vue-property-decorator';

import * as Store from '../../store';
import { slugify } from '../../commons/slug';
import {
    LotSuggestions,
    emptyLotSuggestions,
} from '../../utils/lot-suggestions';

import moment from 'moment';

import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import PizZipUtils from 'pizzip/utils/index.js';
import ImageModule from 'docxtemplater-image-module-free';
import { saveAs } from 'file-saver';
import https from 'https';
import Stream from 'stream';
import CKEditor from 'ckeditor4-vue';
import draggable from 'vuedraggable';

import WinnersTab from './winners-tab/winners-tab.vue';
import DepositorsTab from './depositors-tab/depositors-tab.vue';
import CancelledBidsTab from './cancelled-bids-tab/cancelled-bids-tab.vue';

@Component({
    components: { ckeditor: CKEditor.component, draggable, 'winners-tab': WinnersTab, 'depositors-tab': DepositorsTab, 'cancelled-bids-tab': CancelledBidsTab },
})
export default class ManageAuction extends ComponentWithSocket {
    public websiteUrl = 'https://vikart.ro';

    public data: {
        id: string;
        addUserError: string;
        addUserOpen: boolean;
        qrUserOpen: boolean;
        qrUserId: string;
        auction: any;
        lots: any[];
        auctionUsers: any[];
        newNotification: any;
        startDate: string;
        startTime: string;
        authors: any[];
        lotSuggestions: LotSuggestions;
    } = {
        id: '',
        addUserError: '',
        addUserOpen: false,
        qrUserOpen: false,
        qrUserId: '',
        auction: undefined,
        auctionUsers: [],
        lots: [],
        newNotification: {},
        startDate: '',
        startTime: '',
        authors: [],
        lotSuggestions: emptyLotSuggestions(),
    };

    public addUser: {
        firstName: string;
        lastName: string;
        email: string;
        phone: string;
        paddle: number;
    } = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        paddle: 0,
    };

    public sellLot: {
        lot: any;
        auctionUser: any;
        price: number;
    } = {
        lot: undefined,
        auctionUser: undefined,
        price: 0,
    };

    selectedCurrency: string = 'EUR';
    activeTabIndex: number = 0;
    isMobile: boolean = false;

    ckeditorConfig: any = {
        entities_latin: false,
        basicEntities: false,
        language: 'en',
    };

    public addLotModal: {
        isOpen: boolean;
        isLoading: boolean;
        error: string;
        lot: any;
        lots: any[];
        searchTimeout: any;
    } = {
        isOpen: false,
        isLoading: false,
        error: '',
        lot: undefined,
        lots: [],
        searchTimeout: undefined,
    };

    public updateLot: {
        id: string;
        object: any;
        auctionCatalog: any;
        featuredImage: any;
        coverImage: any;
        isModalOpen: boolean;
        updateLotError: string;
    } = {
        auctionCatalog: undefined,
        featuredImage: undefined,
        coverImage: undefined,
        id: '',
        object: {},
        isModalOpen: false,
        updateLotError: '',
    };

    public lotImagesModal: {
        images: any;
        lotId: string;
        isOpen: boolean;
    } = {
        images: {},
        lotId: '',
        isOpen: false,
    };

    public moveLots: {
        selectedLots: string[];
        isModalOpen: boolean;
        targetAuction: any;
        availableAuctions: any[];
        isLoading: boolean;
        error: string;
    } = {
        selectedLots: [],
        isModalOpen: false,
        targetAuction: undefined,
        availableAuctions: [],
        isLoading: false,
        error: '',
    };

    constructor() {
        super();

        this.wsListener.onGet('auctions', (success: boolean, data: any) => {
            Store.commitLoaderVisibility(this.$store, false);

            if (success) {
                if (data && !data.slug) {
                    data.slug = slugify(data.name);
                }
                this.data.auction = this.withVideoUrls(data);

                const [startDate, startTime] = moment(data.startDate)
                    .format('DD-MM-YYYY HH:mm')
                    .split(' ');

                this.data.startDate = startDate;
                this.data.startTime = startTime;

                // Fix needed for not replacing the images
                this.data.auction.image = '';
                this.data.auction.imageCover = '';
            }
        });

        this.wsListener.onGet('admin.lots', (success: boolean, data: any) => {
            Store.commitLoaderVisibility(this.$store, false);

            if (success) {
                this.data.lots = data;
            }
        });

        this.wsListener.onGet(
            'admin.auctions.users',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.auctionUsers = data;
                }
            },
        );

        this.wsListener.onPost(
            'admin.auctions.users',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.addUserError = '';
                    this.data.addUserOpen = false;
                    this.addUser = {
                        firstName: '',
                        lastName: '',
                        email: '',
                        phone: '',
                        paddle: 0,
                    };
                    this.wsListener.sendGet('admin.auctions.users', {
                        auction: this.data.id,
                    });
                } else {
                    this.data.addUserError = data;
                }
            },
        );

        this.wsListener.onPost(
            'auctions.setup',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.auction.status = 1;
                } else {
                    this.data.auction.status = 3;
                }
            },
        );

        this.wsListener.onPost(
            'auctions.setup.lots',
            (success: boolean, data: any) => {
                this.data.lots.unshift(data.log);
                this.data.auction = this.withVideoUrls(data.auction);
            },
        );

        this.wsListener.onPut(
            'admin.auctions',
            (success: boolean, data: any) => {
                if (success) {
                    Store.commitLoaderVisibility(this.$store, false);
                } else {
                    alert(data);
                }
            },
        );

        this.wsListener.onPost(
            'admin.auctions.notification.new',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (success) {
                    this.data.newNotification = {};

                    alert('Notificarea a fost trimisa cu success');
                } else {
                    alert(data);
                }
            },
        );

        this.wsListener.onPost(
            'admin.auctions.lots.sell',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (success) {
                    this.sellLot.lot = undefined;
                    this.sellLot.auctionUser = undefined;
                    this.sellLot.price = 0;

                    this.wsListener.sendGet('photographer.lots', {
                        auction: this.data.id,
                    });
                } else {
                    alert(data);
                }
            },
        );

        this.wsListener.onPost('photographer.lot.photo', (success: boolean) => {
            if (success) {
                this.reloadLots();

                this.lotImagesModal.images = [];
                this.lotImagesModal.lotId = '';
                this.lotImagesModal.isOpen = false;
            } else {
                Store.commitLoaderVisibility(this.$store, false);
            }
        });

        this.wsListener.onPut(
            'admin.auctions.lots',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (success) {
                    this.updateLot.updateLotError = '';

                    this.data.lots = this.data.lots.map(el => {
                        if (el._id === this.updateLot.id) {
                            return {
                                ...this.updateLot.object,
                                ...data,
                            };
                        }
                        return el;
                    });
                    this.updateLot.isModalOpen = false;
                    this.updateLot.object = {};
                } else {
                    this.updateLot.updateLotError =
                        'A aparut o eroare la editarea lotului';
                    alert(data);
                }
            },
        );

        this.wsListener.onDelete(
            'admin.auctions.lots',
            (success: boolean, data: any) => {
                if (success) {
                    this.reloadLots();
                } else {
                    Store.commitLoaderVisibility(this.$store, false);
                    alert(data);
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors.contracts.authors',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.authors = data;
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors.contracts.lots.suggestions',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.lotSuggestions = data;
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors.contracts.lots',
            (success: boolean, data: any) => {
                this.addLotModal.isLoading = false;
                if (success && data) {
                    this.addLotModal.lots = data
                        .filter((item: any) => item.author)
                        .reverse();
                }
            },
        );

        this.wsListener.onPost(
            'admin.auctions.lots',
            (success: boolean, data: any) => {
                if (success) {
                    this.reloadLots();

                    this.addLotModal.isOpen = false;
                    this.addLotModal.lot = undefined;
                } else {
                    Store.commitLoaderVisibility(this.$store, false);
                    this.addLotModal.error =
                        'A aparut o eroare. Te rugam sa incerci mai tarziu.';
                    alert(data);
                }
            },
        );

        this.wsListener.onPut(
            'admin.auctions.lots.chooseBid',
            (success: boolean, data: any) => {
                if (success) {
                    this.reloadLots();
                } else {
                    Store.commitLoaderVisibility(this.$store, false);

                    this.addLotModal.error = 'A aparut o eroare. Te rugam sa incerci mai tarziu.';
                    alert(data);
                }
            },
        );
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    updateIsMobile() {
        this.isMobile = window.innerWidth < 768;
    }

    // Returns false to cancel any drag-reorder of lots on mobile, so positions
    // can't be changed by accident on touch. Reads the live width so it never
    // depends on reactive state toggling at the right moment.
    checkLotMove() {
        return window.innerWidth >= 768;
    }

    mounted() {
        this.updateIsMobile();
        window.addEventListener('resize', this.updateIsMobile);

        this.data.id = this.$root.$route.params.id;

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('auctions', {
            _id: this.data.id,
        });

        this.reloadLots();

        this.wsListener.sendGet('admin.auctions.users', {
            auction: this.data.id,
        });

        this.wsListener.sendGet('admin.depositors.contracts.authors');
        this.wsListener.sendGet('admin.depositors.contracts.lots.suggestions');
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.updateIsMobile);
    }

    /**
     * Reincarca loturile licitatiei. Se cheama si din tab-uri copil care
     * modifica loturile (ex. mutarea in alt contract schimba pretul), ca
     * tabul Loturi si editarea sa nu ramana pe valorile vechi.
     */
    reloadLots() {
        this.wsListener.sendGet('admin.lots', {
            auction: this.data.id,
        });
    }

    goLive() {
        this.wsListener.sendPost('auctions.setup', {
            _id: this.data.auction._id,
        });
    }

    beautifyDateTime(dtt: any) {
        return moment(dtt).format('llll');
    }

    timeAgo(dtt: any) {
        return moment(dtt).fromNow();
    }

    updateLotsOrder() {
        let lotsOrder: any = {};

        for (let lotIndex in this.data.lots) {
            lotsOrder[this.data.lots[lotIndex].lot._id] =
                parseInt(lotIndex) + 1;
        }

        this.wsListener.sendPost('admin.lots.ordering', {
            auction: this.data.auction._id,
            lotsOrder: lotsOrder,
        });
    }

    async updateAuctionSettings() {
        Store.commitLoaderVisibility(this.$store, true);

        // Build the date
        this.data.auction.startDate = moment(
            this.data.startDate + ' ' + this.data.startTime,
            'DD-MM-YYYY HH:mm',
        ).toDate();

        try {
            // Add the images & catalog
            if (this.updateLot.featuredImage)
                this.data.auction.image = await this.convertToBase64(
                    this.updateLot.featuredImage,
                );
            if (this.updateLot.coverImage)
                this.data.auction.imageCover = await this.convertToBase64(
                    this.updateLot.coverImage,
                );
            if (this.updateLot.auctionCatalog)
                this.data.auction.catalogPdf = await this.convertToBase64(
                    this.updateLot.auctionCatalog,
                );
        } catch (error) {
            console.error('File upload err:', error);
        }

        // videoUrl ramane primul video, pentru clientii care nu stiu de videoUrls
        this.data.auction.videoUrls = this.data.auction.videoUrls.filter(
            (url: string) => url.trim(),
        );
        this.data.auction.videoUrl = this.data.auction.videoUrls[0] || '';

        this.wsListener.sendPut('admin.auctions', {
            ...this.data.auction,
        });
    }

    // Licitatiile vechi au doar videoUrl; il aducem in lista inainte sa devina reactiv
    withVideoUrls(auction: any) {
        if (!auction.videoUrls || !auction.videoUrls.length) {
            auction.videoUrls = auction.videoUrl ? [auction.videoUrl] : [];
        }
        return auction;
    }

    addVideoUrl() {
        this.data.auction.videoUrls.push('');
    }

    removeVideoUrl(index: number) {
        this.data.auction.videoUrls.splice(index, 1);
    }

    sendAuctionNotification() {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('admin.auctions.notification.new', {
            _id: this.data.auction._id,
            title: this.data.newNotification.title,
            content: this.data.newNotification.content,
        });
    }

    addAuctionUser() {
        this.wsListener.sendPost('admin.auctions.users', {
            auction: this.data.auction._id,
            user: this.addUser,
        });
    }

    doSellLot() {
        if (
            !this.sellLot.lot ||
            !this.sellLot.auctionUser ||
            !this.sellLot.price
        ) {
            alert('Te rugam sa completezi toate datele din formular');
            return;
        }

        if (
            !confirm(
                `Esti sigur ca vrei sa vinzi lotul ${
                    this.sellLot.lot.name
                } utilizatorului ${this.sellLot.auctionUser.firstName} ${
                    this.sellLot.auctionUser.lastName
                } pentru suma de ${this.sellLot.price} ? `,
            )
        ) {
            return;
        }

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('admin.auctions.lots.sell', {
            auction: this.data.auction._id,
            lot: this.sellLot.lot._id,
            auctionUser: this.sellLot.auctionUser._id,
            price: this.sellLot.price,
        });
    }

    qrUserOpen(user: any) {
        this.data.qrUserOpen = true;
        this.data.qrUserId = user._id;
    }

    get hasReportsAccess() {
        let user = Store.readLoggedInUser(this.$store);
        return user && user.hasReportsAccess;
    }

    get currencySymbol() {
        if (this.selectedCurrency == 'EUR') return '€';
        return 'Lei';
    }

    get isAdmin() {
        let user = Store.readLoggedInUser(this.$store);
        return user && user.isAdmin;
    }

    formatPrice(amount: number) {
        if (this.selectedCurrency == 'EUR') return amount;
        return amount * this.data.auction.euroRate;
    }

    loadFile(url: string, callback: any) {
        PizZipUtils.getBinaryContent(url, callback);
    }

    replaceErrors(key: any, value: any) {
        if (value instanceof Error) {
            return Object.getOwnPropertyNames(value).reduce(
                (error: any, key: string) => {
                    error[key] = (value as any)[key];
                    return error;
                },
                {},
            );
        }

        return value;
    }

    getHttpData(url: any, callback: any) {
        url = url.replace(
            'storage.googleapis.com/vikart-production',
            'vikart-production.storage.googleapis.com',
        );

        https
            .request(url, function(response) {
                if (response.statusCode !== 200) {
                    return callback(
                        new Error(
                            `Request to ${url} failed, status code: ${
                                response.statusCode
                            }`,
                        ),
                    );
                }

                const data = new Stream.Transform();
                response.on('data', function(chunk) {
                    data.push(chunk);
                });
                response.on('end', function() {
                    callback(undefined, data.read());
                });
                response.on('error', function(e) {
                    callback(e);
                });
            })
            .end();
    }

    async doGenerateLabels() {
        let $this = this;

        $this.loadFile('/static/template_eticheta_v2.docx', async function(
            error: any,
            content: any,
        ) {
            if (error) {
                throw error;
            }

            // Below the options that will be passed to ImageModule instance
            let opts: any = {};
            opts.centered = false; // Set to true to always center images
            opts.fileType = 'docx'; // Or pptx

            opts.getImage = function(tagValue: any, tagName: any) {
                return new Promise(function(resolve, reject) {
                    $this.getHttpData(tagValue, function(err: any, data: any) {
                        if (err) {
                            return reject(err);
                        }
                        resolve(data);
                    });
                });
            };
            opts.getSize = function(img: any, tagValue: any, tagName: any) {
                return [150, 90];
            };

            let imageModule = new ImageModule(opts);

            const options = {
                parser: function(tag: any) {
                    return {
                        get: function(scope: any, context: any) {
                            if (tag === '$index') {
                                const indexes = context.scopePathItem;
                                return indexes[indexes.length - 1] + 1;
                            }
                            return scope[tag];
                        },
                    };
                },
                modules: [imageModule],
            };

            let zip = new PizZip(content);
            let doc = new Docxtemplater(zip, options);

            let lots = $this.data.lots.map(lot => {
                let author_info = lot.attributes[0]
                    ? lot.attributes[0].value
                    : '';
                let lot_description = lot.description.replace(
                    /<(.|\n)*?>/g,
                    '',
                );
                lot_description = lot_description.replace(
                    'INFORMAȚII SUPLIMENTARE:',
                    '',
                );
                lot_description = lot_description.replace(
                    'Pentru informații în legătură cu starea de conservare a loturilor,',
                    '',
                );
                lot_description = lot_description.replace(
                    'vă rugăm să ne contactați la numerele afișate pe site.',
                    '',
                );
                lot_description = lot_description.replace('&#8222;', '„');
                lot_description = lot_description.replace('&#8221;', '”');
                lot_description = lot_description.replace('&nbsp;', '');

                return {
                    lot_name: lot.name.split(', ')[0],
                    lot_description,
                    author_name: lot.author && lot.author.name,
                    author_info: lot.author && lot.author.info,
                    position: lot.position,
                    from: lot.estimateMin,
                    to: lot.estimateMax,
                    logo: '/static/logo.png',
                    auction: $this.data.auction.name.toUpperCase(),
                };
            });

            // Get the right data and push it to the document
            await doc.resolveData({
                lots: lots,
            });

            try {
                doc.render();
            } catch (error) {
                console.log(
                    JSON.stringify({ error: error }, $this.replaceErrors),
                );

                if (
                    error.properties &&
                    error.properties.errors instanceof Array
                ) {
                    const errorMessages = error.properties.errors
                        .map(function(error: any) {
                            return error.properties.explanation;
                        })
                        .join('\n');

                    console.log('errorMessages', errorMessages);
                }

                throw error;
            }

            let out = doc.getZip().generate({
                type: 'blob',
                mimeType:
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            }); // Output the document using Data-URI

            saveAs(out, $this.data.auction.name + '.docx');
        });
    }

    convertToBase64(image: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                if (!e.target) {
                    reject(new Error('No target'));
                    return;
                }

                resolve(e.target.result);
            };

            reader.onerror = error => {
                reject(error);
            };

            reader.readAsDataURL(image);
        });
    }

    copyToClipboard(text: string) {
        (window.navigator as any).clipboard.writeText(text);
    }

    reorderLots() {
        if (this.isMobile) {
            return;
        }

        if (this.isAdmin) {
            this.wsListener.sendPut('admin.auctions.lots.reorder', {
                lots: this.data.lots,
            });
        }
    }

    openLotImagesModal(id: string, images: any) {
        this.lotImagesModal.lotId = id;
        this.lotImagesModal.isOpen = true;
        this.lotImagesModal.images = images.map((el: any) => el.thumbnail);
    }

    addLotImages(id: string) {
        this.lotImagesModal.images = [];
        let input: any = document.getElementById(id);

        if (input.files.length > 10) {
            alert('Te rugăm să introduci maxim 10 poze');
            return;
        }

        if (input && input.files) {
            for (let i = 0; i < input.files.length; i++) {
                const FR = new FileReader();

                FR.addEventListener('load', (e: any) => {
                    this.lotImagesModal.images.push(e.target.result);
                    console.log(this.lotImagesModal.images);
                });

                FR.readAsDataURL(input.files[i]);
            }
        }
    }

    updateLotImages() {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPost('photographer.lot.photo', {
            lot: this.lotImagesModal.lotId,
            images: this.lotImagesModal.images,
        });
    }

    selectWinner(lot: any, bid: any) {
        if (confirm('Esti sigur ca vrei sa modifici castigatorul lotului?')) {
            Store.commitLoaderVisibility(this.$store, true);

            this.wsListener.sendPut('admin.auctions.lots.chooseBid', {
                bid,
                lot,
            });
        }
    }

    openLotUpdateModal(lot: any) {
        let $this: any = this;
        this.updateLot.id = lot._id;
        this.updateLot.object = lot;

        const dimensionsAtr = lot.attributes.find(
            (el: any) => el.name === 'Dimensiuni',
        ) || { value: '' };

        const fabricOrTechniqueAtr = lot.attributes.find(
            (el: any) => el.name === 'Material / Tehnica',
        ) || { value: '' };

        // Atributul poate exista fara valoare, iar `vue-typeahead-bootstrap`
        // nu emite `input` cand `value` e `undefined`.
        this.updateLot.object = Object.assign(
            {
                authorName: lot.author ? lot.author.name : '',
                authorInfo: lot.author ? lot.author.info : '',
                dimensions: dimensionsAtr.value || '',
                fabricOrTechnique: fabricOrTechniqueAtr.value || '',
            },
            lot,
        );

        if (!this.updateLot.object.slug) {
            const authorName = this.updateLot.object.authorName || '';
            this.updateLot.object.slug = slugify(
                authorName
                    ? `${authorName} ${this.updateLot.object.name}`
                    : this.updateLot.object.name,
            );
        }

        this.updateLot.isModalOpen = true;

        setTimeout(() => {
            $this.$refs.authorTypeaheadEdit.inputValue = this.updateLot.object.authorName;
        }, 20);
    }

    cancelUpdateLot() {
        this.updateLot.isModalOpen = false;
        this.updateLot.id = '';
        this.updateLot.object = {};
    }

    @Watch('updateLot.object.authorName')
    updateAuthorInfo(val: any) {
        this.updateLot.object.author = '';
        const author = this.data.authors.find((el: any) => el.name === val);
        if (author) {
            this.updateLot.object.author = author._id;
            this.updateLot.object.authorInfo = author.info || '';
        }
    }

    doUpdateLot() {
        if (confirm('Esti sigur ca vrei sa editezi acest lot?')) {
            Store.commitLoaderVisibility(this.$store, true);

            this.wsListener.sendPut(
                'admin.auctions.lots',
                this.updateLot.object,
            );
        }
    }

    doDeleteLot(lot: any) {
        if (confirm('Esti sigur ca vrei sa stergi acest lot?')) {
            Store.commitLoaderVisibility(this.$store, true);

            this.wsListener.sendDelete('admin.auctions.lots', {
                _id: lot._id,
            });
        }
    }

    searchLots(keyword: string) {
        clearTimeout(this.addLotModal.searchTimeout);

        if (keyword.length > 2) {
            this.addLotModal.searchTimeout = setTimeout(() => {
                this.addLotModal.isLoading = true;
                this.addLotModal.error = '';
                this.wsListener.sendGet('admin.depositors.contracts.lots', {
                    isUnavailable: false,
                    sold: false,
                    keyword,
                });
            }, 500);
        } else {
            this.addLotModal.lots = [];
        }
    }

    addLotToAuction() {
        Store.commitLoaderVisibility(this.$store, true);
        this.wsListener.sendPost('admin.auctions.lots', {
            auction: this.data.id,
            lots: [this.addLotModal.lot],
        });
    }

    get lotsWithoutWinner() {
        return this.data.lots.filter(lot => !lot.winnerUser);
    }

    get allLotsSelected() {
        if (this.lotsWithoutWinner.length === 0)
            return false;

        return this.lotsWithoutWinner.every(lot =>
            this.moveLots.selectedLots.indexOf(lot._id) > -1
        );
    }

    toggleAllLots() {
        if (this.allLotsSelected) {
            this.moveLots.selectedLots = [];
        } else {
            this.moveLots.selectedLots = this.lotsWithoutWinner.map(lot => lot._id);
        }
    }

    toggleLotSelection(lotId: string) {
        const index = this.moveLots.selectedLots.indexOf(lotId);

        if (index > -1) {
            this.moveLots.selectedLots.splice(index, 1);
        } else {
            this.moveLots.selectedLots.push(lotId);
        }
    }

    isLotSelected(lotId: string) {
        return this.moveLots.selectedLots.indexOf(lotId) > -1;
    }

    async openMoveLotsModal() {
        this.moveLots.isModalOpen = true;
        this.moveLots.isLoading = true;
        this.moveLots.error = '';

        try {
            const response = await fetch(`${process.env.API2_URL}/auction?status=0`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const data = await response.json();
            this.moveLots.availableAuctions = data.data || data || [];
            this.moveLots.isLoading = false;
        } catch (error) {
            console.error('Error loading auctions:', error);
            this.moveLots.error = 'A aparut o eroare la incarcarea licitatiilor';
            this.moveLots.isLoading = false;
        }
    }

    async doMoveLots() {
        if (!this.moveLots.targetAuction) {
            alert('Te rugam sa selectezi o licitatie');
            return;
        }

        if (this.moveLots.selectedLots.length === 0) {
            alert('Te rugam sa selectezi cel putin un lot');
            return;
        }

        if (!confirm(`Esti sigur ca vrei sa muti ${this.moveLots.selectedLots.length} loturi in licitatia selectata?`)) {
            return;
        }

        try {
            const response = await fetch(`${process.env.API2_URL}/update-lots?token=c8f02a40c3fa8e6383228cc95242aac3`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    auction: this.moveLots.targetAuction.id,
                    lots: this.moveLots.selectedLots,
                }),
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const data = await response.json();

            if (data.success) {
                alert(data.message || 'Loturile au fost mutate cu succes');
                this.moveLots.isModalOpen = false;
                this.moveLots.selectedLots = [];
                this.moveLots.targetAuction = undefined;

                // Reload lots
                this.reloadLots();
            } else {
                throw new Error(data.message || 'A aparut o eroare');
            }
        } catch (error) {
            console.error('Error moving lots:', error);
            alert('A aparut o eroare la mutarea loturilor');
        }
    }

    cancelMoveLots() {
        this.moveLots.isModalOpen = false;
        this.moveLots.targetAuction = undefined;
        this.moveLots.error = '';
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/auction-manage/index.ts